import { render, staticRenderFns } from "./passwordlogin.vue?vue&type=template&id=6e724823&scoped=true&"
import script from "./passwordlogin.vue?vue&type=script&lang=js&"
export * from "./passwordlogin.vue?vue&type=script&lang=js&"
import style0 from "./passwordlogin.vue?vue&type=style&index=0&id=6e724823&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e724823",
  null
  
)

export default component.exports